<template>
  <div>
    <div
      v-if="campaign.html"
      class="my-12"
    >
      <div
        class="campaign-preamble"
        :data-translation="campaign?.html_translationkey"
        v-html="campaign.html"
      />
    </div>
    <div
      v-else
      class="mt-12"
    />
    <template v-if="campaign.special_videointroduction?.length">
      <LazyMediaLogoCard
        v-for="(videoIntroduction, idx) in specialVideoIntroductions"
        :key="idx"
        :logo="videoIntroduction.logo"
        :title="videoIntroduction.quote"
        :title-by="videoIntroduction.quote_by"
        :text="videoIntroduction.text"
        :media="videoIntroduction.media"
      />
    </template>
    <LazyCategoryFirstTripCard
      v-else-if="firstTrip"
      :trip="firstTrip"
    />
    <div id="campaignActionBtnScrollToElement">
      <CategoryCards
        class="mt-12"
        :list="list"
        :loading="false"
      />
      <h4
        v-if="list.length === 0"
        class="text-center py-12 text-slate-500 font-normal print-hidden mt-12"
      >
        <span data-i18n="categoryCurrentlyEmpty">
          {{ $t('categoryCurrentlyEmpty') }}
        </span>
        <span class="ml-2">
          {{ campaign.topic }}
        </span>
      </h4>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    campaign: {
      type: Object,
      required: true,
    },

    firstTrip: {
      type: Object,
      default: null,
    },
  },

  computed: {
    list () {
      return [
        ...(this.campaign.triptypes || []),
        ...(this.campaign.destinations || []),
      ]
    },

    specialVideoIntroductions () {
      return this.campaign?.special_videointroduction?.map(videoIntroduction => ({
        ...videoIntroduction,
        logo: {
          url: videoIntroduction.cloudinary_logo,
        },
        media: {
          mediatype: 'video',
          type: videoIntroduction.movie_type,
          location: videoIntroduction.movie_id,
          customThumbnail: {
            url: videoIntroduction.cloudinary_image,
          },
        },
      }))
    },
  },
})
</script>

<style lang="scss">
@import "@layers/web/assets/scss/modules/product/_product-trip-result";

.compaign_content {
  .searchresult {
    margin: 40px 0 !important;
  }
}

.top-section {
  @media (max-width: theme('screens.lg')) {
    margin-top: 0;
  }
}

/*! purgecss start ignore */
.campaign-preamble {
  h1, h2, h3 {
    // Chunk of HTML from Filemaker, hence no helper classes
    font-family: theme('fontFamily.serif');
    margin-bottom: 1rem;
  }
}
/*! purgecss end ignore */
</style>
